import { useCallback, useMemo } from 'react';
import { useSnackbar } from 'notistack';

const useNotify = () => {    
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const variants = useMemo(() => ({
        INFO: 'info',
        WARNING: 'warning',
        ERROR: 'error',
        SUCCESS: 'success',
        DEFAULT: 'default'
    }), [])

    const Notify = useCallback((message, variant, options = {}) => 
        enqueueSnackbar(message, { variant, autoHideDuration: 3000, ...options })
    , [enqueueSnackbar]);

    const CloseNotify = (key) =>
        closeSnackbar(key);

    return {
        Notify,
        CloseNotify,
        variants
    }
}

export default useNotify;